import React from 'react';

import { connect } from 'react-redux';
import { useConfiguration } from '../../../../ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { ProviderEntity } from '../../../../../models/provider';
import { OauthStoreDescription } from '../../../../../stores/oauth-store';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../../stores/redux-store';
import { useUrlQuery } from '../../../../ApplicationProviders/UrlQueryProvider/UrlQueryProvider';
import {
  ClientLegalDisclaimer as ClientLegalDisclaimerImport,
  ClientLegalDisclaimerProps,
  showClientLegalTexts,
} from '../../../../../core/components/ClientLegalDisclaimer/ClientLegalDisclaimer';
import { UseGradualRollout } from '../../../../../utilities/useGradualRollout';
import {
  TinkLegalDisclaimer as TinkLegalDisclaimerImport,
  TinkLegalDisclaimerProps,
} from './TinkLegalDisclaimer';
import {
  TinkLegalDisclaimerConsent as TinkLegalDisclaimerConsentImport,
  TinkLegalDisclaimerConsentProps,
} from './TinkLegalDisclaimerConsent';

export type LegalDisclaimerAuthOwnProps = {
  provider?: ProviderEntity;
};

type LegalDisclaimerAuthProps = PropsFromRedux &
  LegalDisclaimerAuthOwnProps & {
    TinkLegalDisclaimer?: React.ComponentType<TinkLegalDisclaimerProps>;
    ClientLegalDisclaimer?: React.ComponentType<ClientLegalDisclaimerProps>;
    TinkLegalDisclaimerConsent?: React.ComponentType<TinkLegalDisclaimerConsentProps>;
    isMobile?: boolean;
    useGradualRollout?: UseGradualRollout;
  };

export const LegalDisclaimerAuthPresenter: React.FC<LegalDisclaimerAuthProps> = ({
  provider,
  oauthDescription,
  // isMobile = userAgent.isMobile,
  TinkLegalDisclaimer = TinkLegalDisclaimerImport,
  ClientLegalDisclaimer = ClientLegalDisclaimerImport,
  TinkLegalDisclaimerConsent = TinkLegalDisclaimerConsentImport,
}) => {
  const configuration = useConfiguration();
  const { clientId } = useUrlQuery();

  const { clientName = '', clientUrl = '', scopesDescriptionsList = [] } = oauthDescription ?? {};
  // Disabled due to bug
  // const providerHasNoFields = provider && !Provider.hasFields(provider);
  const shouldShowConsentRedirectScreen = false; // isMobile && providerHasNoFields && isProviderPreselected;

  const shouldShowClientLegalDocs = showClientLegalTexts({
    clientId,
    configuration: configuration.data,
  });

  if (shouldShowClientLegalDocs) {
    return <ClientLegalDisclaimer clientId={clientId} clientName={clientName} />;
  }

  if (shouldShowConsentRedirectScreen) {
    return (
      <TinkLegalDisclaimerConsent
        provider={provider}
        clientName={clientName}
        clientUrl={clientUrl}
        featureFlags={configuration.data.featureFlags}
        scopesDescriptionsList={scopesDescriptionsList}
      />
    );
  }

  return (
    <TinkLegalDisclaimer
      provider={provider}
      clientName={clientName}
      clientUrl={clientUrl}
      featureFlags={configuration.data.featureFlags}
      scopesDescriptionsList={scopesDescriptionsList}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    userId: state.user.user?.id,
    oauthDescription: state.oauth.description as OauthStoreDescription,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const LegalDisclaimerAuth = connector(LegalDisclaimerAuthPresenter);
